var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "table-row-detail-container loading-wrapper",
      class: { "is-loading": _vm.objectFormDisabled },
    },
    [
      _c("div", { staticClass: "grid-x grid-padding-x" }, [
        _c("div", { staticClass: "cell", staticStyle: { flex: "1" } }, [
          _c("dl", { staticClass: "stacked" }, [
            _c("dt", [_vm._v(_vm._s(_vm.$t("form.project.location")))]),
            _vm._v(" "),
            _c("dd", [_vm._v(_vm._s(_vm.object.location.company_name))]),
            _vm._v(" "),
            _c("dt", [_vm._v(_vm._s(_vm.$t("form.city")))]),
            _vm._v(" "),
            _c("dd", [_vm._v(_vm._s(_vm.object.address.city))]),
            _vm._v(" "),
            _c("dt", [_vm._v(_vm._s(_vm.$t("form.project.pm")))]),
            _vm._v(" "),
            _c("dd", [
              _vm._v(
                _vm._s(_vm.object.account.profile.firstname) +
                  " " +
                  _vm._s(_vm.object.account.profile.lastname)
              ),
            ]),
            _vm._v(" "),
            _c("dt", [_vm._v(_vm._s(_vm.$t("mobile")))]),
            _vm._v(" "),
            _c("dd", [
              _vm._v(_vm._s(_vm.object.account.profile.communication.mobile)),
            ]),
            _vm._v(" "),
            _c("dt", [_vm._v(_vm._s(_vm.$t("phone")))]),
            _vm._v(" "),
            _c("dd", [
              _vm._v(_vm._s(_vm.object.account.profile.communication.phone)),
            ]),
            _vm._v(" "),
            _c("dt", [_vm._v(_vm._s(_vm.$t("mail")))]),
            _vm._v(" "),
            _c("dd", [
              _vm._v(_vm._s(_vm.object.account.profile.communication.email)),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "cell",
            staticStyle: { width: "110px", "min-width": "110px" },
          },
          [
            _c("span", { staticClass: "table-status table-status--right" }, [
              _c("span", { staticClass: "status-icon status-icon--busy" }, [
                _vm._v(_vm._s(_vm.$t("status.busy"))),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "table-label" }, [
                _vm._v(
                  _vm._s(_vm.$helpers.formatNumber(_vm.layersStats.finished))
                ),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "table-description" }, [
                _vm._v(_vm._s(_vm.$t("qm"))),
              ]),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "table-status table-status--right" }, [
              _c("span", { staticClass: "status-icon status-icon--open" }, [
                _vm._v(_vm._s(_vm.$t("status.open"))),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "table-label" }, [
                _vm._v(_vm._s(_vm.$helpers.formatNumber(_vm.layersStats.open))),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "table-description" }, [
                _vm._v(_vm._s(_vm.$t("qm"))),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "cell",
            staticStyle: { width: "256px", "min-width": "256px" },
          },
          [
            _c("dl", [
              _c("dt", [_vm._v(_vm._s(_vm.$t("form.project.layer_hole")))]),
              _vm._v(" "),
              _c("dd", [
                _vm._v(
                  _vm._s(_vm.object.layer_hole ? _vm.$t("yes") : _vm.$t("no"))
                ),
              ]),
              _vm._v(" "),
              _c("dt", [_vm._v(_vm._s(_vm.$t("form.project.layer_tok")))]),
              _vm._v(" "),
              _c("dd", [
                _vm._v(
                  _vm._s(_vm.object.layer_tok ? _vm.$t("yes") : _vm.$t("no"))
                ),
              ]),
              _vm._v(" "),
              _c("dt", [_vm._v(_vm._s(_vm.$t("form.project.layer_width")))]),
              _vm._v(" "),
              _c(
                "dd",
                [
                  _vm.object.showLayerWidth
                    ? [
                        _vm._v(
                          _vm._s(_vm.object.layer_width_min) +
                            " - " +
                            _vm._s(_vm.object.layer_width_max) +
                            " " +
                            _vm._s(_vm.$t("m"))
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm.object.layers.length >= 1
        ? [
            _c(
              "div",
              { staticClass: "form" },
              [
                _vm._l(_vm.object.layers, function (layer, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "form-group" },
                    [
                      _c("v-projects-table-detail-row-layer", {
                        attrs: {
                          layerType: layer,
                          layerValue: layer.layer_log,
                          cancelled: _vm.objectFormCancelled,
                        },
                        on: { onFinishLayer: _vm.onFinishLayer },
                      }),
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _vm.$store.getters.userHasPermission("project_qm_update") &&
                    !_vm.objectFormCancelled
                      ? [
                          _c(
                            "button",
                            {
                              staticClass: "button",
                              attrs: {
                                role: "button",
                                type: "submit",
                                title: _vm.$t("form.submit.save"),
                                disabled: _vm.objectFormDisabled,
                              },
                              on: { click: _vm.onSubmitObject },
                            },
                            [_vm._v(_vm._s(_vm.$t("form.submit.save")))]
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ],
              2
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.objectFormDisabled
        ? _c("div", { staticClass: "loading-message" }, [
            _vm._v(_vm._s(_vm.$t("results_loading"))),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }